import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Body} from 'shells/typography/body';

import type {GetWorkOsInformation_workOs_domainInfo as DomainInfo} from 'nutshell-graphql-types';

import {DomainsTable} from './domains-table';

type Props = {
    domainInfo: DomainInfo;
};

export function SsoDomains(props: Props) {
    const hasAtLeastOneDomain = props.domainInfo.domains.length > 0;

    const handleDomainAdminPortal = () => {
        // @ts-expect-error
        window.open(props.domainInfo.adminPortal, '_blank');
    };

    return (
        <>
            <div className='flex'>
                <Body size='small' isBold={true}>
                    Configure your single sign-on domain names
                </Body>
            </div>
            <div className='flex mt-8'>
                <DomainsTable
                    domainInfo={props.domainInfo}
                    actionItem={
                        <Button
                            variant='primary'
                            size='small'
                            onClick={handleDomainAdminPortal}
                            className='mr-8'
                            icon={ExternalLinkIcon}
                        >
                            {hasAtLeastOneDomain ? 'Manage' : 'Configure'}
                        </Button>
                    }
                />
            </div>
        </>
    );
}
